import { render } from "./achievement.vue?vue&type=template&id=ff6aefe0&scoped=true"
import script from "./achievement.vue?vue&type=script&lang=js"
export * from "./achievement.vue?vue&type=script&lang=js"

import "./achievement.vue?vue&type=style&index=0&id=ff6aefe0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ff6aefe0"

export default script